<!--
 * @Description: 车型识别一体机-右
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-24 15:57:14
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-25 09:55:08
 -->
<template>
  <div class="rightModule">
    <div class="topPart">
      <div class="titleHeader">
        <img src="/static/img/layout/arrow-orange.png" alt="">
        <span class="titleName">产品特点</span>
      </div>
      <div class="content">
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">集成车牌识别、车型识别、图像处理于一体，多角度监控，智能补光一体化设计</span></div>
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">深度学习算法，结合大数据模型，算法成熟，识别率高</span></div>
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">符合《高速公路称重检测业务规范和技术要求》，完全满足高速公路入口治超的“三张图”抓拍和不少于5S视频保存的需要</span></div>
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">符合《收费公路车辆通行费车型分类（JT489-2019）》车辆分类新标准</span></div>
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">单侧安装在收费岛上，不破坏收费岛结构</span></div>
        <div class="item"><i class="el-icon-circle-check"></i><span class="text">系统方便升级、可适应未来出现的新车型，无需改动硬件设备</span></div>
      </div>
      <div class="characteristicStatistics">
        <div class="item">
          <div class="insideItem">
            <div class="value">>99%</div>
            <div class="label">车辆捕获率</div>
          </div>
        </div>
        <div class="item">
          <div class="insideItem">
            <div class="value">>98%</div>
            <div class="label">车牌识别正确率</div>
          </div>
        </div>
        <div class="item">
          <div class="insideItem">
            <div class="value">>98%</div>
            <div class="label">车型识别率</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottomPart">
      <div class="titleHeader">
        <img src="/static/img/layout/arrow-orange.png" alt="">
        <span class="titleName">应用案例</span>
      </div>
      <div class="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rightModule',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .rightModule {
    width: 82%;
    height: 100%;
    .topPart {
      height: calc(50% - 8vh);
      padding-top: 8vh;
      .titleHeader {
        width: 100%;
        height: 4vh;
        background: url('/static/img/layout/titleHeaderBg.png');
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        >img {
          height: 100%;
          margin-right: 20px;
        }
        .titleName {
          font-family: SourceHanSansCN-Bold;
          font-size: 1.5vh;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #05dbe3;
        }
      }
      .content {
        width: 100%;
        .item {
          font-size: 1.5vh;
          color: #05dbe3;
          display: flex;
          justify-content: space-between;
          .el-icon-circle-check {
            font-size: 1.8vh;
            font-weight: bold;
            margin-right: 10px;
            display: inline-block;
            width: 3%;
            line-height: 3vh;
          }
          .text {
            display: inline-block;
            width: 97%;
            line-height: 3vh;
            color: rgb(10, 178, 167);
          }
        }
      }
      .characteristicStatistics {
        width: 100%;
        height: 5vh;
        display: flex;
        justify-content: space-between;
        margin-top: 2vh;
        .item {
          display: inline-block;
          width: 30%;
          height: 100%;
          background: linear-gradient(to left, #9ceff1, #9ceff1) left top no-repeat,
                      linear-gradient(to bottom, #9ceff1, #9ceff1) left top no-repeat,
                      linear-gradient(to left, #9ceff1, #9ceff1) right top no-repeat,
                      linear-gradient(to bottom, #9ceff1, #9ceff1) right top no-repeat,
                      linear-gradient(to left, #9ceff1, #9ceff1) left bottom no-repeat,
                      linear-gradient(to bottom, #9ceff1, #9ceff1) left bottom no-repeat,
                      linear-gradient(to left, #9ceff1, #9ceff1) right bottom no-repeat,
                      linear-gradient(to left, #9ceff1, #9ceff1) right bottom no-repeat;
          background-size: 2px 20px, 20px 2px, 2px 20px, 20px 2px;
          .insideItem {
            width: 100%;
            height: 100%;
            background: rgba(20, 76, 89, 0.4);
            .value {
              text-align: center;
              color: #fff;
              font-size: 1.8vh;
              line-height: 2.6vh;
              font-weight: bold;
              margin-bottom: 0.2vh;
            }
            .label {
              text-align: center;
              color: rgb(9, 236, 255);
              font-size: 1.4vh;
            }
          }
        }
      }
    }
    .bottomPart {
      height: 50%;
      .titleHeader {
        width: 100%;
        height: 4vh;
        background: url('/static/img/layout/titleHeaderBg.png');
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        margin-bottom: 2.5vh;
        >img {
          height: 100%;
          margin-right: 20px;
        }
        .titleName {
          font-family: SourceHanSansCN-Bold;
          font-size: 1.5vh;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #05dbe3;
        }
      }
      .content {
        width: 96%;
        height: 28vh;
        border-radius: 6px;
        background: url('/static/img/layout/device.png');
        background-size: 100% 100%;
      }
    }
  }
</style>
